'use strict';

var _ = require('lodash');
var StrategyClosureActionService = function StrategyClosureActionService(StrategyClosureAction, strategyConstants, fcrService) {
  function getFareBasisCodes() {
    return fcrService.getClassesFcrSorted();
  }
  function createAction(actionList, fareBasisCode) {
    var action = new StrategyClosureAction(fareBasisCode, null, null);
    actionList.push(action);
  }
  function fillActions(groups, actions) {
    actions.forEach(function (action) {
      if (groups[action.fareBasisCode]) {
        _.extend(action, groups[action.fareBasisCode]);
      }
    });
  }
  function getActionList(groups) {
    var fareBasisCodes = getFareBasisCodes();
    var actionList = [];
    if (fareBasisCodes.length > 0) {
      actionList = _.transform(fareBasisCodes, createAction);
    }
    if (groups) {
      groups = mapGroups(groups);
      fillActions(groups, actionList);
    }
    return actionList;
  }
  function flattenGroup(conditions) {
    var result = [];
    (function flatten(conditions) {
      if (conditions.children) {
        conditions.children.forEach(function (condition) {
          flatten(condition);
        });
      } else {
        result.push(conditions);
      }
    })(conditions);
    return result;
  }
  function mapGroups(groups) {
    var mappedGroups = {};
    groups.forEach(function (group) {
      var flattenedGroup = flattenGroup(group);
      var mappedGroup = {
        fareBasisCode: getFieldValue(flattenedGroup, strategyConstants.CLASS_CLOSURE.CLASS_NAME_FIELD),
        daysToDeparture: getFieldValue(flattenedGroup, strategyConstants.CLASS_CLOSURE.DTD_FIELD),
        loadFactor: getFieldValue(flattenedGroup, strategyConstants.CLASS_CLOSURE.LOAD_FACTOR_FIELD)
      };
      mappedGroups[mappedGroup.fareBasisCode] = mappedGroup;
    });
    return mappedGroups;
  }
  function getFieldValue(condition, field) {
    var parsedField = _.find(condition, {
      selector: field
    });
    return parsedField ? parsedField.arguments.shift() : null;
  }
  function adjustLoadFactorValues(actionList) {
    _.forEach(actionList, function (strategyClosureAction) {
      if (!_.isNil(strategyClosureAction.loadFactor)) {
        strategyClosureAction.loadFactor = Math.round(strategyClosureAction.loadFactor * 10000) / 100;
      }
    });
  }
  return {
    getActionList: getActionList,
    adjustLoadFactorValues: adjustLoadFactorValues
  };
};
StrategyClosureActionService.$inject = ['StrategyClosureActionFactory', 'StrategyConstants', 'FcrService'];
module.exports = StrategyClosureActionService;